import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ApiResponse, PaginatedResponse } from "@/lib/types";
import { ArtsyProduct, CreateArtsyProductRequest, GetArtsyProductsParams, UpdateArtsyProductRequest } from "@/types/artsyProductTypes";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

export const artsyProductApi = createApi({
  reducerPath: "artsyProductApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: "include",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["ArtsyProduct"],
  endpoints: (builder) => ({
    createArtsyProduct: builder.mutation<ApiResponse<ArtsyProduct>, CreateArtsyProductRequest>({
      query: (data) => ({
        url: "/artsy-product/create-artsy-product",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["ArtsyProduct"],
    }),
    getAllArtsyProducts: builder.query<PaginatedResponse<ArtsyProduct>, GetArtsyProductsParams | void>({
      query: (params) => ({
        url: "/artsy-product",
        params: params || undefined,
      }),
      providesTags: ["ArtsyProduct"],
    }),
    getArtsyProductById: builder.query<ApiResponse<ArtsyProduct>, string>({
      query: (id) => `/artsy-product/${id}`,
      providesTags: ["ArtsyProduct"],
    }),
    updateArtsyProduct: builder.mutation<ApiResponse<ArtsyProduct>, UpdateArtsyProductRequest>({
      query: ({ id, data }) => ({
        url: `/artsy-product/update-artsy-product/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["ArtsyProduct"],
    }),
    deleteArtsyProduct: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/artsy-product/delete-artsy-product/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ArtsyProduct"],
    }),
  }),
});

export const {
  useCreateArtsyProductMutation,
  useGetAllArtsyProductsQuery,
  useGetArtsyProductByIdQuery,
  useUpdateArtsyProductMutation,
  useDeleteArtsyProductMutation,
} = artsyProductApi;
